export default __webpack_public_path__ + "static/hero-mobile_2-97e13a2973ce823de11003a98792cb19.png";